import React from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from 'reactstrap';

function SelectDispenseDateModal({ dispensedt, setDispensedt, openDispenseDateModal, setOpenDispenseDateModal, data }) {
    const dispenseDates = [...new Set(data.map((item) => item.dispenseDt))];
    const formatDate = (date) => {
        const d = new Date(date);
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        const year = d.getFullYear();
        return `${month}/${day}/${year}`;
    };

    const handleSelectDate = (event) => {
        const formattedDate = formatDate(event.target.value);
        setDispensedt(formattedDate);
        setOpenDispenseDateModal(false);
    };

    return (
        <Modal isOpen={openDispenseDateModal} toggle={() => setOpenDispenseDateModal(false)} centered>
            <ModalHeader toggle={() => setOpenDispenseDateModal(false)} className="border-bottom-0 pb-0">
                <h5 className="mb-0 font-weight-bold" style={{ fontSize: '18px', color: 'black' }}>
                    Select Dispense Date
                </h5>
            </ModalHeader>
            <hr style={{ margin: '0px' }} />
            <ModalBody className="pt-3">
                <div className="d-flex align-items-start gap-3">
                    <div className="flex-grow-1 d-flex flex-column gap-2 ml-2">
                        <h5
                            className=" font-weight-bold"
                            style={{ fontSize: '16px', color: 'black', marginBottom: '0' }}>
                            Dispense Date:
                        </h5>
                        <div className="my-2">
                            <select
                                className="form-control"
                                value={dispensedt}
                                onChange={handleSelectDate}
                                style={{
                                    padding: '10px',
                                    borderRadius: '5px',
                                    border: '1px solid #ccc',
                                    width: '100%',
                                    cursor: 'pointer',
                                }}>
                                <option value="" disabled>
                                    Select a Date
                                </option>
                                {data.map((item, index) => (
                                    <option key={index} value={item.dispenseDt} style={{ cursor: 'pointer',}}>
                                        {new Date(item.dispenseDt).toLocaleDateString()} 
                                    </option>
                                ))}
                            </select>
                        </div>
                        <p className="text-muted" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                            Choose a dispense date for the order return. Multiple dispense dates are available for this
                            Rx no. Please select one to continue with the order return process.
                        </p>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter className="border-top-0 pt-0">
                <Button
                    color="gray"
                    onClick={() => setOpenDispenseDateModal(false)}
                    style={{
                        cursor: 'pointer',
                        border: '1px solid #E5E7EB',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        color: '#6B7280',
                    }}
                    className="btn-sm">
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default SelectDispenseDateModal;
